/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  label: {
    id: "b2b.provozni-informace-search.widget.label",
    defaultMessage: "Filter"
  },
  dateFromLabel: {
    id: "b2b.provozni-informace-search.dateFrom.label",
    defaultMessage: "Date from"
  },
  dateToLabel: {
    id: "b2b.provozni-informace-search.dateTo.label",
    defaultMessage: "Date to"
  },
  dateFromPlaceholder: {
    id: "b2b.provozni-informace-search.dateFrom.placeholder",
    defaultMessage: "Enter date from"
  },
  dateToPlaceholder: {
    id: "b2b.provozni-informace-search.dateTo.placeholder",
    defaultMessage: "Enter date to"
  },
  search: {
    id: "b2b.provozni-informace-search.button.search",
    defaultMessage: "Search"
  }
});

export default () => useMessages(MESSAGES);
